/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
    BackOfficeUserModelDto,
    ErrorHttpContentDto,
    LogonResponseModelDto,
} from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class InstitutionsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationValidate
   * @summary Logs onto the system.
   * @request POST:/institutions/{institutionUniversalId}/authentication/validate
   */
  authenticationValidate = (
    institutionUniversalId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<LogonResponseModelDto, ErrorHttpContentDto>({
      path: `/institutions/${institutionUniversalId}/authentication/validate`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthenticationCurrentUser
   * @summary Logs onto the system.
   * @request GET:/institutions/{institutionUniversalId}/authentication/currentuser
   */
  authenticationCurrentUser = (
    institutionUniversalId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<BackOfficeUserModelDto, ErrorHttpContentDto>({
      path: `/institutions/${institutionUniversalId}/authentication/currentuser`,
      method: "GET",
      format: "json",
      ...params,
    });
}
